// extracted by mini-css-extract-plugin
export default {"products":"Lu-z","card":"Mu-z","oosMessaging":"Nu-z"};